// extracted by mini-css-extract-plugin
export var container = "YearHeading-module--container--5a568";
export var content = "YearHeading-module--content--73d4e";
export var notes = "YearHeading-module--notes--1dc7b";
export var subheading = "YearHeading-module--subheading--f3391";
export var year = "YearHeading-module--year--b95d9";